export default __webpack_public_path__ + "static/media/beauty.152b81b9.png";